document.addEventListener("DOMContentLoaded", function () {

  function checkOptions() {
    document.querySelectorAll('.preview-widget-option-wrapper').forEach(wrapper => {
      const name = wrapper
        .querySelector('.preview-widget-option-name')
        ?.textContent.trim().toLowerCase();

      const options = wrapper.querySelector('.preview-widget-option-wrapper-options');
      const count = options ? options.children.length : 0;

      if (name === "color" && count <= 1) {
        wrapper.style.display = "none";
      }
    });
  }

  // Run immediately (if already loaded)
  checkOptions();

  // Watch for new nodes added to DOM
  const observer = new MutationObserver(() => {
    checkOptions();
    updateVaraintImages();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  function updateVaraintImages(){
    const designItems = document.querySelectorAll('.design-element-single-image-wrapper');

    designItems.forEach(item => {

      item.addEventListener('click', function () {

        designItems.forEach(i => i.classList.remove('selected'));
        this.classList.add('selected');

        // Get clicked image src
        const newSrc = this.querySelector('img')?.src;

        console.log("Clicked image:", newSrc);

        const allProductImgs = document.querySelectorAll('.product__media-item img');

        allProductImgs.forEach(img => {
          img.src = removeThumb(newSrc);

          if (img.dataset.src) img.dataset.src = newSrc;
          if (img.dataset.srcset) img.dataset.srcset = newSrc;
          if (img.srcset) img.srcset = newSrc;
        });

        console.log("All product media images updated.");
      });

    });
  }

  function removeThumb(url) {
    return url.replace('thumb-', '');
  }

});
